import React, { useEffect, useState } from 'react';
import { Button as TsButton, Toggle } from '@/components/TSX components';
import { CaretDown, DotsThree } from '@phosphor-icons/react';
import LatestToolTip from '@/components/Tooltip';
import Popper from '@mui/material/Popper';
import Fade from '@mui/material/Fade';
import { ClickAwayListener } from '@mui/material';

export const SourcesElement = ({
  source,
  user,
  ind,
  selected,
  setSelected,
  handleDeleteColumn,
  setColEditModalOpen,
  setSelectedColDetails,
  setColDataModalOpen,
  setColumnDetails,
  logos,
}) => {
  const [hovering, setHovering] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const index = ind + 1;

  function handleClick(event) {
    setAnchorEl(anchorEl ? null : event.currentTarget);
  }

  let platform =
    logos.data?.integrations?.filter((logo) => logo.slug === source.platform) ||
    [];

  useEffect(() => {
    setSelected(0);
  }, []);

  return (
    <div
      className={`flex flex-col px-2 border border-pv-neutral-grey-100 rounded-lg py-3 hover:bg-pv-primary-primary-50 cursor-pointer ${
        selected === index ? `` : `justify-center`
      } 
      ${hovering ? `bg-pv-primary-primary-50` : ``}
      `}
      style={{
        height: selected === index ? 'fit-content' : '58px',
        boxShadow: hovering ? '0px 8px 24px 0px #9090901A' : '',
      }}
      onMouseEnter={() => {
        setHovering(true);
      }}
      onMouseLeave={() => {
        setHovering(false);
      }}
      onClick={(e) => {
        if (
          e.target.classList.value.includes('column-list-button') ||
          e.target.classList.value === ''
        ) {
        } else {
          setSelected((prev) => (prev === index ? 0 : index));
        }
      }}
    >
      <div
        className={`grid text-xs text-pv-text-secondary-text ${
          selected === index ? `pt-2` : `items-center`
        }`}
        style={{
          gridTemplateColumns: '3% 12% 12% 12% 10% 34% 14% 3%',
        }}
      >
        <span
          className={`px-2 h-full ${
            selected === index
              ? `h-full pt-0.5`
              : `h-fit max-h-8 overflow-hidden`
          }`}
        >
          {hovering ? (
            <CaretDown
              className={`transform ${selected === index ? `rotate-180` : ``}`}
              style={{
                transition: 'all 0.3s ease',
              }}
            />
          ) : (
            `${index}.`
          )}
        </span>
        <button
          className={`px-2 w-fit flex overflow-hidden text-left text-pv-text-primary-text hover:text-pv-primary-primary-500 hover:underline ${
            selected === index ? `` : `max-h-8 multine-ellipsis`
          }`}
          style={{
            wordBreak: 'break-all',
          }}
          onClick={(e) => {
            e.stopPropagation();
            setSelectedColDetails(source);
            setColEditModalOpen(true);
          }}
          disabled={user?.role.toLowerCase() !== 'admin'}
        >
          {source.label}
        </button>
        <span
          className={`m-0 px-2 h-full flex gap-2 ${
            selected === index ? `` : `h-fit max-h-8 overflow-hidden`
          }`}
        >
          <img
            src={
              platform?.[0]?.logo || source.tableDetails?.integration_logo || ''
            }
            alt=""
            style={{
              width:
                platform?.[0]?.logo || source.tableDetails?.integration_logo
                  ? '16px'
                  : '0',
              height: 'fit-content',
              aspectRatio: 1,
            }}
          />
          <span
            className={`${selected === index ? `` : `overflow-hidden multine-ellipsis`}`}
            style={{
              width: 'calc(100% - 24px)',
              wordBreak: 'break-all',
            }}
          >
            {source.tableDetails?.name || source.tableName || '-'}
          </span>
        </span>
        <span
          className={`px-2 overflow-hidden ${
            selected === index ? `` : `max-h-8`
          }`}
          style={{
            wordBreak: 'break-all',
          }}
        >
          {source.name || '-'}
        </span>
        <span
          className={`px-2 flex items-center ${
            selected === index
              ? `transform -translate-y-0.5 h-fit`
              : `h-full max-h-8 overflow-hidden`
          }`}
        >
          <span
            className={`inline-block w-fit rounded-lg capitalize bg-pv-tags-blue py-1 px-1.5 text-xxs`}
          >
            {source.type || '-'}
          </span>
        </span>
        <p
          className={`m-0 px-2 h-full ${
            selected === index
              ? ``
              : `h-fit max-h-8 overflow-hidden multine-ellipsis`
          }`}
        >
          {source.description || `-`}
        </p>
        <div
          className={`px-2 h-full flex transform text-pv-primary-primary-500 hover:text-pv-primary-primary-800 cursor-pointer ${
            selected === index ? `` : `h-fit max-h-8 overflow-hidden`
          }`}
        >
          <button
            className="w-fit h-fit"
            onClick={(e) => {
              e.stopPropagation();
              setColDataModalOpen(true);
              setColumnDetails(source);
            }}
          >
            View&nbsp;sample&nbsp;data
          </button>
        </div>
        <>
          <button
            className={`flex justify-center w-fit h-fit rounded ${
              selected === index ? `transform -translate-y-1` : ``
            } ${user?.role.toLowerCase() !== 'admin' ? `` : `hover:bg-pv-primary-primary-100`}`}
            onClick={(e) => {
              handleClick(e);
            }}
            disabled={user?.role.toLowerCase() !== 'admin'}
          >
            <DotsThree size={24} className="column-list-button" />
          </button>
          <Popper
            open={anchorEl}
            anchorEl={anchorEl}
            placement="bottom-end"
            transition
          >
            {({ TransitionProps }) => (
              <ClickAwayListener
                onClickAway={() => {
                  setAnchorEl(null);
                }}
              >
                <Fade {...TransitionProps} timeout={250}>
                  <div
                    className="bg-white flex flex-col rounded-lg border border-brand-ai-gray-400 relative h-fit max-h-60 mt-2"
                    style={{
                      boxShadow: `0px 8px 24px 0px rgba(0, 0, 0, 0.10)`,
                    }}
                  >
                    <div className="flex flex-col">
                      <button
                        className="flex py-3 px-4 hover:bg-pv-primary-primary-50"
                        onClick={(e) => {
                          e.stopPropagation();
                          setSelectedColDetails(source);
                          setColEditModalOpen(true);
                          setAnchorEl(null);
                        }}
                      >
                        Edit
                      </button>
                      <button
                        className="flex py-3 px-4 hover:bg-pv-primary-primary-50"
                        onClick={(e) => {
                          e.stopPropagation();
                          handleDeleteColumn(source);
                          setAnchorEl(null);
                        }}
                      >
                        Remove
                      </button>
                    </div>
                  </div>
                </Fade>
              </ClickAwayListener>
            )}
          </Popper>
        </>
      </div>
      {selected === index && (
        <div
          className="grid mt-3 pt-3 border-t border-pv-neutral-grey-100 justify-between"
          style={{
            gridTemplateColumns: '32% 32% 32%',
          }}
        >
          <div className="px-2 flex flex-col gap-2">
            <span className="text-xs text-pv-text-secondary-text font-medium">
              Data fill %
            </span>
            <p className="text-pv-text-secondary-text text-xs">
              {source?.nonNullValuePercentage === null
                ? 'N/A'
                : source.nonNullValuePercentage + '%'}
            </p>
          </div>
          <div className="px-2 flex flex-col gap-2">
            <span className="text-xs text-pv-text-secondary-text font-medium">
              Connected fields
            </span>
            <p className="leading-7">
              {Array.isArray(source.mappings) && source.mappings.length > 0 ? (
                source.mappings.map((mapping, index) => {
                  return (
                    <span className="text-xxs text-pv-text-primary-text">
                      {index !== 0 && <span> &nbsp;|&nbsp; </span>}
                      <span className="inline-block px-1.5 py-1 bg-pv-primary-primary-100 rounded-lg">
                        {mapping.foreignField}
                      </span>
                    </span>
                  );
                })
              ) : (
                <span className="text-xs">-</span>
              )}
            </p>
          </div>
          <div className="px-2 flex flex-col gap-2">
            <span className="text-xs text-pv-text-secondary-text font-medium">
              Tags
            </span>
            <p className="leading-7">
              {Array.isArray(source.tags) && source.tags.length > 0 ? (
                source.tags.map((tag, index) => {
                  return (
                    <span className="text-xxs text-pv-text-primary-text">
                      {index !== 0 && <span> &nbsp;|&nbsp; </span>}
                      <span className="inline-block px-1.5 py-1 bg-pv-primary-primary-100 rounded-lg">
                        {tag.name}
                      </span>
                    </span>
                  );
                })
              ) : (
                <span className="text-xs">-</span>
              )}
            </p>
          </div>
        </div>
      )}
    </div>
  );
};
